import {FC, useEffect, useState} from "react";
import { MONTH_ARRAY } from "../constants";
import { QuoteSvg } from "./QuoteSvg";
import "./styles.css";
import {Spin} from "antd";
import React from "react";
import 'antd/dist/antd.min.css';

const dateToday = new Date();

export interface TotalTaxProp {
    fetchData: () => Promise<number>
}

export const TotalTaxes: FC<TotalTaxProp> = (props) => {

    const [totalTaxes, setTotalTaxes] = useState<number>(0)
    const [loading, setLoading] = useState(true)

    const loadData = async ()=> {
        return await props.fetchData() || 0
    }

    useEffect(()=>{
        setLoading(true)
        loadData().then(data => {
            setTotalTaxes(data)
            setLoading(false)
        })
    },[])

    return <div className="eas-taxes-end-sales--main">
        <h2>
            Total Taxes Collected for{" "}
            {`${MONTH_ARRAY[dateToday.getUTCMonth()]} ${dateToday.getUTCFullYear()}`}
        </h2>
        <div className="total-taxes--grid">
            {loading? (
            <div
                style={{
                    fontSize: "26px",
                    fontWeight: "bold",
                    color: "#016193",
                    marginRight: "40px",
                }}
            >
            <Spin style={{ marginRight: '40px' }}/>
            </div>) :
                (<div
                    style={{
                        fontSize: '26px',
                        fontWeight: 'bold',
                        color: '#016193',
                        marginRight: '40px',
                    }}
                >
                {new Intl.NumberFormat("de-DE", {
                    style: "currency",
                    currency: "EUR",
                }).format(totalTaxes)}
            </div>)}
            <div
                style={{
                    display: "flex",
                }}
            >
                <div
                    style={{
                        marginRight: "20px",
                        fill: "#016193",
                    }}
                >
                    <QuoteSvg/>
                </div>
                <div>
                    Please notice. This is approximate amount of taxes to be paid to
                    Authorities. Accurate amount of taxes will be available at the
                    beginning of next month in the Fiscal VAT reports.
                    <br/>
                    During VAT reports generation special Exchange rates, provided by EU
                    and UK authorities, will be applied, corrections and returns will be
                    taken into account as well.
                </div>
            </div>
        </div>
    </div>
};
